/**
 * One rule for "may this account create new content right now?", shared by every
 * create entry point so they can't drift.
 *
 * Reads the backend's own answer (`payment.dunning.isLimited`) rather than mapping a
 * list of ladder states, which is what it used to do. The states are no longer sent to
 * the browser, and mirroring them here always risked drifting from open-api's guard —
 * both now read the same flag.
 *
 * This is the CLIENT half of enforcement for the Designer specifically, whose
 * create/save never reaches open-api's guard (separate out-of-process service). For
 * non-designer writes the server guard is still the real gate; this dialog is the
 * courteous heads-up that stops the editor opening in the first place.
 *
 * An account excluded by staff has `isLimited: false` written for it, so "the server
 * lets these writes through, and so must the client" needs no special case here.
 */
export function isContentCreationBlocked(
  me: { payment?: { dunning?: { isLimited?: boolean | null } | null } | null } | null | undefined,
): boolean {
  return me?.payment?.dunning?.isLimited === true;
}
